import React, { useState, useEffect } from 'react'
import { Tag, message, Button, Form, Input, Table, Switch, Space, Modal, TreeSelect, Radio, InputNumber } from 'antd'
import { ExclamationCircleOutlined } from '@ant-design/icons'
import ResourceApi from '@api/resource'
import MyIcon from "@components/MyIcon"
import { createMenu, deleteMenu, editMenu } from '@api/menu'
import './index.scss'


const layout = {
    labelCol: {
        span: 4,
    },
    wrapperCol: {
        span: 20,
    },
}
const Menu = (props) => {

    const [form] = Form.useForm()
    const [editId,setEditId] = useState([])
    const [resourceTree, setResourceTree] = useState([])
    const [treeData, setTreeData] = useState([])
    const [checkStrictly, setCheckStrictly] = useState(false)
    const [loading,setLoading] = useState(true)

    const [isModalOpen, setIsModalOpen] = useState(false)
    const [modelModify,setModelModify] = useState('add')

    useEffect(() => {
        list ()
        return () => { }
    }, [])

    const onFinish = (values) => {
        console.log('Success:', values);
    };
    const onFinishFailed = (errorInfo) => {
        console.log('Failed:', errorInfo);
    };
    // 递归处理数据
    const getTreeData = (data) => {
        for (var i = 0; i < data.length; i++) {
            if (data[i].children.length < 1) {
                data[i].children = undefined
                data[i].title = data[i].name
                data[i].value = data[i].id
            } else {
                data[i].title = data[i].name
                data[i].value = data[i].id
                getTreeData(data[i].children)
            }
        }
        return data
    }

    const showModel = (type,params) => {
        if ( type === 'add' &&  params) {
            form.setFieldsValue({pid: params.id})
        }
        if ( type === 'edit' && params ) {
            setEditId(params.id)
            form.setFieldsValue({...params})
        }

        setModelModify(type)
        setIsModalOpen(true)

    }

    // 处理新增或编辑的数据
    const submiteForm = () => {
        form.validateFields().then( async values => {
            const params = JSON.parse(JSON.stringify(values))
            params.pid = params.pid ? params.pid : 0
            if (modelModify === 'add') {
                const res = await createMenu(params)
                if ( res.status !== '0' ) return
                list()
                form.resetFields()
                setIsModalOpen(false)
                message.success('创建成功')
            } else {
                params.id = editId
                const res = await editMenu(params)
                if ( res.status !== '0' ) return
                list()
                form.resetFields()
                setIsModalOpen(false)
                message.success('修改成功')
            }
        })
    }

    // 删除菜单
    const delMenu = (id) => {
        Modal.confirm({
            title: '删除菜单',
            icon: <ExclamationCircleOutlined />,
            content: '此操作将永久删除该菜单, 是否继续?',
            okText: '确认',
            cancelText: '取消',
            onOk: async () => {
                const res = await deleteMenu({id})
                if ( res.status !== '0' ) return
                message.success('删除成功')
                list()
            }
        })
    }

    const list = () => {
        ResourceApi.getResourceAllForTree().then(res => {
          if (res.status == 0) {
            const handleData = getTreeData(res.data)
            setResourceTree(handleData)
            setTreeData([{
                title: '主类目',
                value: 0,
                children: handleData
            }])
            setLoading(false)
          }
        })
    }

    const resetForm = () => {
        form.resetFields()
        setIsModalOpen(false)
    }

    const columns = [
        {
            title: '菜单名称',
            dataIndex: 'name',
            width: 300,
            key: 'name',
        },
        {
            title: '排序',
            dataIndex: 'sort',
            width: 60,
            key: 'sort',
        },
        {
            title: '路由地址',
            width: 250,
            dataIndex: 'url',
            key: 'url',
        },
        {
          title: '权限标识符',
          width: 250,
          dataIndex: 'perms',
          key: 'perms',
      },
        {
            title: '类型',
            dataIndex: 'type',
            key: 'type',
            width: 60,
            render: (type) => <span>{type ? '按钮' : '菜单'}</span>
        },
        {
            title: '图标',
            dataIndex: 'menuIcon',
            key: 'menuIcon',
            width: 60,
            render: (menuIcon) => {
                return (
                    menuIcon && <MyIcon type={menuIcon} />
                )
            }
        },
        {
            title: '操作',
            key: 'action',
            width: 300,
            fixed: 'right',
            align: 'center',
            render: (record) => {
                return (
                    <Space size="middle">
                        <Tag onClick={ () => showModel('add',{id: record.id}) } color="#87d068">新增</Tag>
                        <Tag onClick={ () => showModel('edit',record) } color="#2db7f5">编辑</Tag>
                        <Tag onClick={ () => delMenu(record.id) } color="#f50">删除</Tag>
                    </Space>
                )
            },
        }
    ]

    return (
        <div className="menu-container">
            <div className='menu-search'>
                <Form
                    name="basic"
                    labelCol={{
                        span: 8,
                    }}
                    wrapperCol={{
                        span: 16,
                    }}
                    initialValues={{
                        remember: true,
                    }}
                    onFinish={onFinish}
                    onFinishFailed={onFinishFailed}
                    autoComplete="off"
                    layout="inline"
                >
                    {/* <Form.Item
                        label="菜单名称"
                        name="name"
                    >
                        <Input placeholder="请输入菜单名称" />
                    </Form.Item>
                    <Form.Item
                        wrapperCol={{
                            offset: 8,
                            span: 16,
                        }}
                    >
                        <Button type="primary" htmlType="submit">搜索</Button>
                    </Form.Item> */}
                    <Form.Item
                        wrapperCol={{
                            offset: 8,
                            span: 16,
                        }}
                    >
                        <Button type="primary" onClick={ () => showModel('add') }>新增</Button>
                    </Form.Item>
                </Form>
            </div>
            <div className='menu-table'>
                <Table
                    columns={columns}
                    rowKey={record => record.id}
                    dataSource={resourceTree}
                    pagination={false}
                    loading={loading}
                />
            </div>

            {/* 新增弹出层 */}
            <Modal title={modelModify == 'add' ? '添加菜单' : '编辑菜单'} open={isModalOpen} onOk={submiteForm} onCancel={resetForm}>
                <Form {...layout} form={form} autoComplete="off">
                    <Form.Item
                        name="pid"
                        label="上级菜单"
                        initialValue={0}
                    >
                        <TreeSelect
                            showSearch
                            style={{
                                width: '100%',
                            }}
                            dropdownStyle={{
                                maxHeight: 400,
                                overflow: 'auto',
                            }}
                            placeholder="请选择上级菜单"
                            allowClear
                            treeData={treeData}
                        />
                    </Form.Item>
                    <Form.Item
                        name="type"
                        label="菜单类型"
                        initialValue={0}
                    >
                        <Radio.Group>
                            <Radio value={0}>菜单</Radio>
                            <Radio value={1}>按钮</Radio>
                        </Radio.Group>
                    </Form.Item>
                    <Form.Item
                        name="name"
                        label="菜单名称"
                        rules={[
                            {
                              required: true,
                              message: '请输入菜单名称',
                            },
                          ]}
                    >
                        <Input placeholder='请输入菜单名称' />
                    </Form.Item>
                    <Form.Item
                        name="sort"
                        label="排序序号"
                        rules={[
                            {
                              required: true,
                              message: '请输入排序序号',
                            },
                          ]}
                          initialValue={0}
                    >
                        <InputNumber min={0} max={100} />
                    </Form.Item>
                    <Form.Item
                        name="url"
                        label="路由地址"
                    >
                        <Input placeholder='请输入路由地址' />
                    </Form.Item>
                    <Form.Item
                        name="perms"
                        label="权限标识符"
                    >
                        <Input placeholder='请输入权限标识符' />
                    </Form.Item>
                    {/* <Form.Item
                        name="prefix"
                        label="平台标识符"
                    >
                        <Input placeholder='请输入平台标识符' />
                    </Form.Item> */}
                    <Form.Item
                        name="menuIcon"
                        label="菜单图标"
                    >
                        <Input placeholder='请输入菜单图标' />
                    </Form.Item>
                    <Form.Item
                        name="nameEn"
                        label="资源标识符"
                    >
                        <Input placeholder='请输入资源标识符' />
                    </Form.Item>
                </Form>
            </Modal>
            {/* /新增弹出层 */}
        </div>
    )
}

export default Menu